import api from './api';

const dashboardService = {
  getOperational: async () => (await api.get('/dashboard/operational')).data,
  getDecisions: async () => (await api.get('/dashboard/decisions')).data,
  getFunnel: async () => (await api.get('/dashboard/funnel')).data,

  // All three are scoped server-side to the organisations the user owns or administers.
  getAll: async () => {
    const [operational, decisions, funnel] = await Promise.all([
      dashboardService.getOperational(),
      dashboardService.getDecisions(),
      dashboardService.getFunnel()
    ]);
    return { operational, decisions, funnel };
  }
};

export default dashboardService;
